import ICommand from '../../../FrontApplet/Command/ICommand';
import { ITypedCommandEvent } from '../../../FrontApplet/Command/ICommandEvent';
import FrontApplet from '../../../FrontApplet/FrontApplet';
import {
	ManagementPowerClearScheduledRebootsRequest,
	ManagementPowerClearScheduledRebootsResult,
	ManagementPowerGetProprietaryTimersRequest,
	ManagementPowerGetProprietaryTimersResult,
	ManagementPowerGetScheduledRebootsRequest,
	ManagementPowerGetScheduledRebootsResult,
	ManagementPowerGetTimersRequest,
	ManagementPowerGetTimersResult,
	ManagementPowerRemoveScheduledRebootRequest,
	ManagementPowerRemoveScheduledRebootResult,
	ManagementPowerSetProprietaryTimerRequest,
	ManagementPowerSetProprietaryTimerResult,
	ManagementPowerSetScheduledRebootRequest,
	ManagementPowerSetScheduledRebootResult,
	ManagementPowerSetTimerRequest,
	ManagementPowerSetTimerResult,
	ManagementPowerUnsetProprietaryTimerRequest,
	ManagementPowerUnsetProprietaryTimerResult,
	ManagementPowerUnsetTimerRequest,
	ManagementPowerUnsetTimerResult,
	PowerAppRestartRequest,
	PowerAppRestartResult,
	PowerRequests,
	PowerSystemRebootRequest,
	PowerSystemRebootResult,
} from './powerCommands';

export function handleManagementPowerRequests(
	onCommand: (callback: (commandEvent: ITypedCommandEvent<PowerRequests>) => Promise<void>) => void,
	dispatch: <TCommand extends ICommand>(command: TCommand) => Promise<void>,
	frontApplet: FrontApplet,
) {
	onCommand(async (commandEvent: ITypedCommandEvent<PowerRequests>) => {
		switch (commandEvent.command.type) {
			case PowerSystemRebootRequest:
				await dispatch<PowerSystemRebootResult>({
					type: PowerSystemRebootResult,
					result: {},
				});
				await frontApplet.management.power.systemReboot();
				break;
			case PowerAppRestartRequest:
				await dispatch<PowerAppRestartResult>({
					type: PowerAppRestartResult,
					result: {},
				});
				await frontApplet.management.power.appRestart();
				break;
			case ManagementPowerGetTimersRequest:
				await dispatch<ManagementPowerGetTimersResult>({
					type: ManagementPowerGetTimersResult,
					timers: await frontApplet.management.power.getTimers(),
				});
				break;
			case ManagementPowerSetTimerRequest:
				await frontApplet.management.power.setTimer(
					commandEvent.command.timerType,
					commandEvent.command.timeOn,
					commandEvent.command.timeOff,
					commandEvent.command.weekdays,
					commandEvent.command.volume,
				);
				await dispatch<ManagementPowerSetTimerResult>({
					type: ManagementPowerSetTimerResult,
					result: {},
				});
				break;
			case ManagementPowerUnsetTimerRequest:
				await frontApplet.management.power.unsetTimer(commandEvent.command.timerType);
				await dispatch<ManagementPowerUnsetTimerResult>({
					type: ManagementPowerUnsetTimerResult,
					result: {},
				});
				break;
			case ManagementPowerGetProprietaryTimersRequest:
				await dispatch<ManagementPowerGetProprietaryTimersResult>({
					type: ManagementPowerGetProprietaryTimersResult,
					result: await frontApplet.management.power.getProprietaryTimers(),
				});
				break;
			case ManagementPowerSetProprietaryTimerRequest:
				await frontApplet.management.power.setProprietaryTimer(
					commandEvent.command.timerType,
					commandEvent.command.timeOn,
					commandEvent.command.timeOff,
					commandEvent.command.weekdays,
					commandEvent.command.keepAppletRunning,
				);
				await dispatch<ManagementPowerSetProprietaryTimerResult>({
					type: ManagementPowerSetProprietaryTimerResult,
					result: {},
				});
				break;
			case ManagementPowerUnsetProprietaryTimerRequest:
				await frontApplet.management.power.unsetProprietaryTimer(commandEvent.command.timerType);
				await dispatch<ManagementPowerUnsetProprietaryTimerResult>({
					type: ManagementPowerUnsetProprietaryTimerResult,
					result: {},
				});
				break;
			case ManagementPowerClearScheduledRebootsRequest:
				await frontApplet.management.power.clearScheduledReboots();
				await dispatch<ManagementPowerClearScheduledRebootsResult>({
					type: ManagementPowerClearScheduledRebootsResult,
					result: {},
				});
				break;
			case ManagementPowerGetScheduledRebootsRequest:
				await dispatch<ManagementPowerGetScheduledRebootsResult>({
					type: ManagementPowerGetScheduledRebootsResult,
					result: await frontApplet.management.power.getScheduledReboots(),
				});
				break;
			case ManagementPowerRemoveScheduledRebootRequest:
				await frontApplet.management.power.removeScheduledReboot(commandEvent.command.id);
				await dispatch<ManagementPowerRemoveScheduledRebootResult>({
					type: ManagementPowerRemoveScheduledRebootResult,
					result: {},
				});
				break;
			case ManagementPowerSetScheduledRebootRequest:
				await frontApplet.management.power.setScheduledReboot(commandEvent.command.weekdays, commandEvent.command.time);
				await dispatch<ManagementPowerSetScheduledRebootResult>({
					type: ManagementPowerSetScheduledRebootResult,
					result: {},
				});
				break;
			default:
		}
	});
}
